import { toast, TypeOptions } from "react-toastify";
export default function showNotification(type: TypeOptions, message: string) {
  return toast(message, { type });
}
